// extracted by mini-css-extract-plugin
module.exports = {"title":"LogsPage_title__2atWl","navTabWrapper":"LogsPage_navTabWrapper__25xg9"};